import React from 'react'
import { FooterElement } from '../components/Footer/Footer'
import { HeaderElement } from '../components/Header/Header'
import "../privacy.css"

const Privacy = () => (
    <>
        <HeaderElement />
        <div className="container policy_container">
            <h1>Privacy Policy</h1>
            Updated april 05th 2023
            <div style={{ marginBottom: "20px" }}></div>

            <h2>Introduction</h2>
            Matterflies has up to this day released two games called "Ball in the Hole" and "Lupus Master".
            We would like to inform you about our privacy policy regarding your information and data.

            <h3>What data do we collect and why?</h3>
            <p>We don't collect any of user data</p>

            <h3>Advertising</h3>
            <p>Our game incorporates interstitial banner ads as a way to monetize.
            In order for advertising networks to display relevant ads to users they use Advertising IDs.
            To turn off personalized ads please use your Android device's optout settings.</p>

            <h3>Third Party Partners</h3>
            <p>We use Google Play Services in order to host leaderboards and achievements.</p>

            Our third party partners may access your information and operate under their own privacy policy. We encourage you to check their privacy policy, to learn more about their practices for processing information

            Google Play Services : https://policies.google.com/privacy

            If you have any questions regarding our practices feel free to contact us at info@matterflies.com
        </div>
        <FooterElement />
    </>
)

export { Privacy }
